import { createConsumer } from '@rails/actioncable';
import './signature_channel';
import './subscription_intention_channel';
import './mif2_questionnaire_channel';

export default createConsumer();
